import React from 'react';
import './AulaCard.css';
const md5 = require('md5');

interface AulaCardProps {
  instructor: string;
  day: string;
  url?: string;
  instagram?: string;
}

export const AulaCard: React.FC<AulaCardProps> = ({ instructor, day, url, instagram }) => {
  const handleClick = () => {
    if (url && url.trim()) {
      window.open(url, '_blank');
    }
  };

  return (
    <div 
      className={`aula-card ${url && url.trim() ? 'clickable' : ''}`}
      onClick={handleClick}
    >
      <div className="aula-card-row">
        {instagram && instagram.trim() ? (
          <div className="instructor-avatar">
            <img
              src={`https://www.gravatar.com/avatar/${md5(instagram.trim().toLowerCase())}`}
              alt={`Avatar de ${instructor}`}
              width={100}
              height={100}
              style={{ borderRadius: '50%' }}
            />
          </div>
        ) : null}
        <div className="aula-content">
          <h3 className="instructor">{instructor}</h3>
          <p className="day">{day}</p>
          {url && url.trim() && (
            <p className="url-hint">Clique para mais informações</p>
          )}
        </div>
      </div>
    </div>
  );
}; 